import gsap from 'gsap'

export class Stagger {
  constructor () {
    this.stagger()
    this.stagger_single()
  }

  stagger () {
    const items = [...document.querySelectorAll('[animation-stagger]')]
    if (!items.length) return

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return
    }

    // ponytail: pas de y initial — sinon hors viewport en bas de page
    gsap.set(items, { autoAlpha: 0 })

    const play = (els) => {
      const pending = els.filter((el) => !el.dataset.staggerPlayed)
      if (!pending.length) return
      pending.forEach((el) => { el.dataset.staggerPlayed = '1' })
      gsap.fromTo(
        pending,
        { autoAlpha: 0, y: 60 },
        {
          autoAlpha: 1,
          y: 0,
          stagger: 0.2,
          duration: 0.7,
          overwrite: 'auto',
        },
      )
    }

    if (!('IntersectionObserver' in window)) {
      play(items)
      return
    }

    const io = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((e) => e.isIntersecting)
        .map((e) => e.target)
      if (!visible.length) return
      play(visible)
      visible.forEach((el) => io.unobserve(el))
    }, {
      threshold: 0,
      rootMargin: '0px',
    })

    items.forEach((el) => io.observe(el))
  }

  stagger_single () {
    this._elements = document.querySelectorAll('[animation-stagger-single]')

    if (!this._elements.length) return

    this._elements.forEach((element) => {
      const delay = element.getAttribute('animation-stagger-single') || 0

      gsap.set(element, { autoAlpha: 0 })

      gsap.fromTo(
        element,
        { autoAlpha: 0, y: 20 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.7,
          delay,
        },
      )
    })
  }
}
